export default "__VITE_ASSET__CKQzYiPi__"